import { filter, forEach, unionBy, uniqBy } from 'lodash'

/* eslint-disable security/detect-object-injection */
export function transformCollaborator(collab, currentUser, orderDetail) {
  ///Find Index of current user in collab///
  const tmpIndex = collab.findIndex((item) => item.user.id == currentUser.id)
  if (
    tmpIndex != -1 &&
    currentUser.company.id == orderDetail.company.id &&
    collab[tmpIndex].roles.role == 'owner'
  ) {
    const tmpCurrentCollabOwner = {
      ...collab[`${tmpIndex}`],
      roles: {
        permissions: [],
        role: 'owner',
      },
      isOwner: true,
    }
    const tmpData = [...collab]
    tmpData.splice(tmpIndex, 1)
    tmpData.unshift(tmpCurrentCollabOwner)
    const result = [...tmpData].map((item) => {
      return {
        ...item.user,
        roles: item.roles,
        role: item?.roles?.role,
        assignmentId: item.id,
        ...(item.isOwner && { isOwner: true }),
      }
    })
    return result
  } else {
    const tmpData = [...collab]
    const result = [...tmpData].map((item) => {
      return {
        ...item.user,
        roles: item.roles,
        role: item?.roles?.role,
        assignmentId: item.id,
        ...(item.isOwner && { isOwner: true }),
      }
    })
    return result
  }
}

export function tranformCollaboratorForSubmit(collab) {
  return collab.map((item) => {
    return {
      ...(item.assignmentId && { id: item.assignmentId }),
      roles: { role: item.role, permissions: [] },
      user_id: item.id,
    }
  })
}

export function transformCollaboratorFromTemplate(
  templateCollaborator = [],
  currentCollaborator = []
) {
  let pickOwnerOrder = currentCollaborator[0]
  let existingCollaborators = []
  forEach(currentCollaborator, (item, index) => {
    if (index !== 0) {
      existingCollaborators.push({
        assignmentId: item?.id,
        role: item.roles.role,
        ...item,
        ...item.user,
      })
    }
  })

  const convertOwnerOrder = {
    ...pickOwnerOrder?.user,
    assignmentId: pickOwnerOrder?.id,
    isOwner: true,
    role: pickOwnerOrder.roles.role,
    roles: { permission: [], role: pickOwnerOrder.roles.role },
  }
  const filterNotOwner = filter(
    templateCollaborator,
    (item) => item.id !== pickOwnerOrder?.user?.id
  )

  const result = uniqBy(
    [{ ...convertOwnerOrder }, ...existingCollaborators, ...filterNotOwner],
    'id' // Purpose not duplicate new user import
  )

  return result
}

export function transformTemplateForSave(
  data,
  orderId,
  sections,
  collaborator
) {
  return {
    name: data.name ? data.name : data.existingTemplate.name,
    type: 4,
    template_value: {
      time_actions: {
        order_id: orderId,
        sections: sections.map((section) => {
          return {
            display_order: section.display_order,
            name: section.name,
            tasks: section.tasks.map((task) => {
              return {
                value: '',
                name: task.name,
                type: task.type,
                plan_date: null,
                tasks_progress: 'new',
                display_order: task.display_order,
                json_value: {},
                is_template: false,
              }
            }),
          }
        }),
      },
      collaborations: collaborator.map((item) => {
        return {
          id: item.id,
          company: item.company,
          avatar: item.avatar,
          email: item.email,
          first_name: item.first_name,
          last_name: item.last_name,
          property_value: item.property_value,
          role: item.role,
          roles: item.roles,
          status: item.status,
        }
      }),
    },
  }
}
